import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { SurrogateInvitationScreen } from '../SurrogateInvitationScreen';

export const SurrogateInvitationWrapper: FC = () => {
  const { verificationKey } = useParams<{ verificationKey: string }>();

  if (!verificationKey) {
    return <div>Invalid invitation link</div>;
  }

  return (
    <SurrogateInvitationScreen
      initialValues={{
        password1: '',
        password2: '',
        agreeToTerms: false,
      }}
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      onSubmit={async (values) => {
        // console.log('Form submitted:', values);
      }}
      validationSchema={undefined}
      title="Complete Your Registration"
      description="Set your password to complete your registration"
    />
  );
};
